import { useApp } from "context/AppContext";
import EDCFlow from "pages/EDCFlow";
import Questionnaire from "pages/Questionnaire";
import QuestionnaireProvider from "pages/Questionnaire/Context";
import { EDCFlowContextProvider } from "pages/EDCFlow/context";

const QuestionnaireFlow = () => {
	const { isEDCFlow } = useApp();

	if (isEDCFlow) {
		return (
			<EDCFlowContextProvider>
			    <EDCFlow />
		    </EDCFlowContextProvider>
		);
	}

	return (
		<QuestionnaireProvider>
			<Questionnaire />
		</QuestionnaireProvider>
	);
};

export default QuestionnaireFlow;
